import { useTranslation } from 'react-i18next'

import { useErrorInfoModal } from '@features/modal'

import {
  useChoosePaymentPluginMutation,
  usePaymentPluginDetailsLazyQuery,
} from '@shared/generated'

export const useAddPayment = () => {
  const { t: te } = useTranslation('errors')
  const { openErrorInfoModal } = useErrorInfoModal()
  const [ fetchPluginDetails, { data, loading } ] =
    usePaymentPluginDetailsLazyQuery()
  const [ choosePlugin ] = useChoosePaymentPluginMutation()

  const addPayment = async (orderId?: string, backLink?: string) => {
    const result = data?.paymentPluginDetails?.id
      ? { data }
      : await fetchPluginDetails()

    const pluginId = result.data?.paymentPluginDetails?.id

    if (!pluginId) {
      return
    }

    try {
      const { data } = await choosePlugin({
        variables: {
          paymentPluginId: pluginId,
          orderId,
          source: 'client',
        },
      })

      const response = data?.choosePaymentPlugin
      if (!response?.type || !response?.payload) return

      const encodedPayload =
        response.payload[response.type as keyof typeof response.payload]
      if (!encodedPayload) return

      const { paymentFormSettings } = JSON.parse(encodedPayload)

      const backLinkUrl = new URL(
        backLink ?? window.location.href,
        window.location.origin,
      )
      if (response.operationId) {
        backLinkUrl.searchParams.set('operationId', response.operationId)
      }

      const preparedPaymentFormSettings = {
        ...paymentFormSettings,
        backLink: backLinkUrl.toString(),
      }

      window.halyk?.cardverification(preparedPaymentFormSettings)
    }
    catch (error) {
      console.error('Failed to add or process payment:', error)
      openErrorInfoModal({
        description: te('add_payment'),
      })
    }
  }

  return { addPayment, loading }
}
